import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import {uniqBy, groupBy, orderBy,cloneDeep} from 'lodash';
import {KeyValue} from '@angular/common';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {DisclosureModalComponent} from '../disclosure-modal/disclosure-modal';
import {ShopDataService, AssetsService} from '@webu/data';
import {Store} from '@ngrx/store';
import {AppState, selectActiveVehicle, selectMyCurrentPlans, TrackingService} from '@ox/data';
import {fromEvent, Subject, take, takeUntil, tap} from 'rxjs';
import {Copy, Plans, UpdatePlan, Outs, EmitObject} from '@ox/typings';
import {AutoDestroy, SessionStorageService} from '@ox/utils';
import {ServiceModalComponent} from '../service-modal/service-modal';
import {map} from 'lodash';
import {replaceVariable} from '@ox/utils';

const prevNextButtons = [
  {
    // 'none' removes the display from DOM
    // '' overides dislpay with nothing. THis turns the button on visually
    none: {next: 'none', prev: 'none'},
    prev: {next: 'none', prev: ''},
    next: {next: '', prev: 'none'},
    both: {next: '', prev: ''}
  }
];
@Component({
  selector: 'webu-manage-feature-plan',
  templateUrl: './manage-featuredplan.component.html'
})
export class ManageFeaturedPlanComponent implements OnInit, AfterViewInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  bsModalRef?: BsModalRef;
  hideServices = true;
  public innerWidth: any;
  openservices: boolean;
  lessbutton = false;
  nth_time: Plans[] = [];
  selectedindex = 0;
  coulmnsize!: number;
  featureGroup: any;
  uniqueFeatures: any;
  private myCurrentPlans: string[] = [];
  featurePlanLength: number;
  itemsPerSlide = 1;
  private mobileBreakpoint = 480;
  imagevalue: string;
  assetsPlans: string[] = [];
  sampleplanindex: number;
  outs: Outs;
  itemSlideFirstOffset = 0;
  nextButton: any;
  prevButton: any;

  @Input() copy: Copy;
  @Input() updatePlanData: UpdatePlan;
  @Input()
  set selectedProduct(value: Plans) {
    this._selectedProduct = value;
    this.selectedindex = value
      ? this.nth_time?.findIndex(
          (item) => (item && item.code === value.code) || ''
        )
      : -1;
  }
  get selectedProduct() {
    return this._selectedProduct;
  }
  @Input() products: any[];
  @Output() selectedProductChange: EventEmitter<any> = new EventEmitter();
  private _selectedProduct: Plans;

  activeVehicle$ = this.store.select(selectActiveVehicle);

  public featurePopupResponse: string[] = [];
  private windowResizeEvent = fromEvent(window, 'resize')
    .pipe(
      takeUntil(this.destroy$),
      tap(() => {
        this.adjustsItemsPerSlide();
      })
    )
    .subscribe();

  constructor(
    private assetsService: AssetsService,
    private modalService: BsModalService,
    private sessionStorageSvc: SessionStorageService,
    private store: Store<AppState>,
    public trackingService: TrackingService,
    private elementFinder: ElementRef,
    private shopDataService: ShopDataService
  ) {}

  onselected(i: any) {
    this.selectedindex = i;
    this.selectedProductChange.emit(this.nth_time[i]);
  }

  showservices() {
    this.openservices = true;
    this.lessbutton = true;
    this.hideServices = false;
  }

  lessservices() {
    this.openservices = false;
    this.lessbutton = false;
    this.hideServices = true;
  }

  getClass(length: any) {
    if (length >= 3) this.coulmnsize = 4;
    else this.coulmnsize = length === 1 ? 4 : 12 / length;
    return `col-lg-${this.coulmnsize}`;
  }

  getArray(count: number) {
    return new Array(count);
  }

  ngOnInit(): void {
    this.store.select(selectMyCurrentPlans)
      .pipe(take(1))
      .subscribe((myCurrentPlans)=> this.myCurrentPlans = myCurrentPlans??[]);
    this.adjustsItemsPerSlide();
    this.setInitialValues();
    this.setUniqueFeatures();
    this.setFeatureGroup();
    this.updateNthTime();
    this.setSelectedProduct();
    this.getClass(this.nth_time?.length || 0);
  }

  ngAfterViewInit() {
    this.setPrevNextButtons();
    this.handleNavButtons(0);
  }

  setInitialValues(): void {
    this.innerWidth = window.innerWidth;
    this.featurePlanLength = this.updatePlanData?.featuredPlans?.length ?? 0;
  }

  setUniqueFeatures(): void {
    const featuredPlanCodes = this.updatePlanData?.featuredPlans?.map(
      (item: any) => item.planCode
    );

    const features = this.copy?.products
      ?.filter((item: any) => featuredPlanCodes?.includes(item.code))
      .flatMap((item: any) => item.features);

    this.uniqueFeatures =
      features?.reduce(
        (acc: any, feature: any) => ({...acc, [feature.code]: feature}),
        {}
      ) || {};
  }

  setFeatureGroup(): void {
    this.featureGroup = groupBy(
      uniqBy(this.uniqueFeatures, 'code'),
      'featureCategoryCode'
    );
  }

  updateNthTime(): void {
    this.nth_time = this.updateProducts();
    if (this.myCurrentPlans.length === 1) {
      this.nth_time = orderBy(
        this.nth_time,
        [
          (item) => (item && item.code === this.myCurrentPlans[0] ? 0 : 1),
          'priority'
        ],
        ['asc', 'asc']
      );
    }
  }

  setSelectedProduct(): void {
    const footerInfo: EmitObject =
      this.sessionStorageSvc.getFromJson('FooterInfo');
    const productName = footerInfo?.product?.name || this.myCurrentPlans[0];
    if (
      this.myCurrentPlans.length === 1 &&
      (!footerInfo || !footerInfo.selectedBYO.length)
    ) {
      this.selectedindex = this.nth_time.findIndex(
        (item) => item && item.name === productName
      );
      if (this.selectedindex >= 0) {
        this.selectedProductChange.emit(this.nth_time[this.selectedindex]);
      }
    }
  }

  private adjustsItemsPerSlide() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < this.mobileBreakpoint) {
      this.itemsPerSlide = 1;
    } else {
      this.itemsPerSlide = 3;
    }
  }

  reverseKeyOrder = (
    a: KeyValue<string, any>,
    b: KeyValue<string, any>
  ): number => {
    return a.key > b.key ? -1 : b.key > a.key ? 1 : 0;
  };

  filterServices(features: any[]) {
    return this.hideServices ? features.slice(0, 3) : features;
  }

  updateProducts() {
    if (this.uniqueFeatures) {
      return this.products?.map((product) => {
        if (product) {
          const uniqueFeatureByProduct = this.updateFeatures(product);
          product.featureGroup = groupBy(
            uniqueFeatureByProduct,
            'featureCategoryCode'
          );
          const offer = this.updatePlanData?.offers?.find(
            (item) => item?.planCode === product.code
          );
          product.offer = offer;
          product.price = offer?.prices.find(
            (item) => item.billingFrequency === 'MONTHLY'
          );
        }
        return product;
      });
    } else {
      return [];
    }
  }

  updateFeatures(product: any) {
    /**
     * We need to clone this global varaibale. This will allow us to make changes here 
     * without effecting the actual values in the global reference
     * ### cloneDeep(this.uniqueFeatures) ###
    */
    return Object.values(cloneDeep(this.uniqueFeatures)).map((item: any) => {
      item.isAvailable = !!product.features.find(
        (feature: any) => feature?.code === item.code
      );
      return item;
    });
  }

  openDisclosureModal(product?: any) {
    if (!product) return;
    this.bsModalRef = this.modalService.show(DisclosureModalComponent, {
      initialState: {product: [product]}
    });
  }

  openServiceModal(index: number, featureValue: any) {
    const features = this.nth_time[index].features;
    this.sampleplanindex = 0;
    features?.forEach((ele: any, index: number) => {
      if (ele.name === featureValue.name) {
        this.sampleplanindex = index;
      }
    });
    this.bsModalRef = this.modalService.show(ServiceModalComponent, {
      initialState: {
        feature: features ? [...features] : [],
        featureValue: [featureValue]
      }
    });
  }

  openServiceMainModal(index: number) {
    this.outs = this.nth_time[index];
    this.assetsService
      ?.getAssets()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (asset: any) => {
          if (asset) {
            this.featurePopupResponse = asset;
            this.assetsPlans = asset.plans;
            this.assetsPlans.forEach((ele: any) => {
              if (ele.name === this.outs.name) {
                this.imagevalue = ele.planAssets[0].assets[0].urlPath;
              }
            });
            this.bsModalRef = this.modalService.show(ServiceModalComponent, {
              initialState: {
                displayPlanName: [this.outs],
                displayImage: [this.imagevalue]
              }
            });
          }
        },
        error: (error) => {
          console.error('Error fetching assets', error);
        }
      });
  }

  log(event: void | number[]) {
    if (event) {
      if (event[0] > this.itemSlideFirstOffset) {
        this.fireTrackingEvent('button', 'arrow', 'next');
      } else if (event[0] < this.itemSlideFirstOffset) {
        this.fireTrackingEvent('button', 'arrow', 'prev');
      }
      this.itemSlideFirstOffset = event[0];
    }
  }

  fireTrackingEvent(type?: string, name?: string, event?: string) {
    this.trackingService.fireProp10Tracking(
      `shop:update plan:${name}:${type}:${event}`,
      '',
      '',
      event,
      '',
      true
    );
  }

  toTitleCase(value: string) {
    return value.replace(/\w\S*/g, function (text: string) {
      return text.charAt(0).toUpperCase() + text.substring(1).toLowerCase();
    });
  }

  replaceBrand(text: string, brand?: string) {
    if (brand && brand !== 'GMC') {
      brand = this.toTitleCase(brand);
    }
    return replaceVariable(text, {
      Brand: brand || ''
    });
  }

  getCopy(copyKey: string) {
    return this.shopDataService?.getGenericCopy(copyKey);
  }

  setButtons(type: string): void {
    const config = map(prevNextButtons, type).shift();
    this.nextButton.style.display = config.next;
    this.prevButton.style.display = config.prev;
  }

  handleNavButtons(event: number) {
    this.prevButton && this.nextButton
      ? this.determineButtons(event)
      : this.setPrevNextButtons();
  }

  determineButtons(event: number) {
    if (this.featurePlanLength < this.itemsPerSlide) {
      this.setButtons('none'); // Turn off both buttons
    } else {
      if (event === 0) {
        this.setButtons('next'); //Turn on only next
      } else if (event > 0 && event < this.featurePlanLength - 1) {
        this.setButtons('both'); //Turn on both buttons
      } else {
        this.setButtons('prev'); //Turn on only prev
      }
    }
  }

  setPrevNextButtons(): void {
    if (!this.prevButton)
      this.prevButton = this.elementFinder.nativeElement.querySelector(
        '.carousel-control-prev'
      );
    if (!this.nextButton)
      this.nextButton = this.elementFinder.nativeElement.querySelector(
        '.carousel-control-next'
      );
  }
}